import React from 'react';
import { IElementDataSectionCustomFields } from 'components/common/element-data/types';
import CustomFields from 'components/common/element-data/parts/CustomFields';

export default function CustomFieldsSection(props: IElementDataSectionCustomFields) {
    const { settings, ...element } = props;
    return (
        <>
            <CustomFields {...element} settings={settings} />
        </>
    );
}
